/* eslint-disable */
import { FC } from 'react'
import Layout from '@/templates/Layout/Layout'

import { constructBreadcrumbJsonSchema } from '@/utils/functions/jsonSchema'
import { getStrapiGraphqlData } from '@/utils/api/wrapper'
import { GetStaticProps } from 'next'
import { individualPolicyQuery } from '@/utils/queries/policies'
import Policy from '@/templates/Policy/Policy'
import {
  INSTANT_REVALIDATION,
  TEN_MINS_REVALIDATION
} from '@/utils/constants/revalidation'
import { capture404PageError } from '@/utils/functions/elk-server'

interface IProps {
  policy: PolicyPage
}

const RevisionPolicy: FC<IProps> = ({ policy }) => {
  const {
    title: seoTitle,
    canonical,
    description: seoDescription
  } = policy?.Seo
  const breadcrumbs: Breadcrumb[] = [
    {
      name: 'Pepper Content',
      url: '/'
    },
    {
      name: seoTitle ?? '',
      url: policy.slug
    }
  ]
  return (
    <Layout
      title={seoTitle ?? ''}
      canonical={canonical ?? ''}
      meta={[
        {
          property: 'description',
          content: seoDescription
        },
        {
          property: 'og:description',
          content: seoDescription
        }
      ]}
      jsonSchema={[constructBreadcrumbJsonSchema(breadcrumbs)]}
    >
      {policy && <Policy policy={policy} />}
    </Layout>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const slug = 'revision-policy'
  const result = await getStrapiGraphqlData<PolicyPageQuery>(
    individualPolicyQuery.loc?.source.body,
    { slug }
  )
  const page = result?.policy?.data?.[0]

  if (!page) {
    capture404PageError(`/revision-policy/`)
    return { notFound: true, revalidate: INSTANT_REVALIDATION }
  }

  return {
    props: {
      policy: page.attributes
    },
    revalidate: TEN_MINS_REVALIDATION
  }
}

export default RevisionPolicy
